var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditopc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V2C1.69779e-06 1.45 0.196001 0.979002 0.588001 0.587002C0.980001 0.195002 1.45067 -0.000664969 2 1.69779e-06H10L16 6V9.1L8 17.075V20H2ZM10 20V17.875L15.15 12.7L17.3 14.8L12.125 20H10ZM18.025 14.1L15.9 11.975L16.6 11.275C16.8 11.075 17.0417 10.975 17.325 10.975C17.6083 10.975 17.8417 11.075 18.025 11.275L18.725 12C18.9083 12.2 19 12.4377 19 12.713C19 12.9883 18.9083 13.2173 18.725 13.4L18.025 14.1ZM9 7H14L9 2V7Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.8711L15 12.5L17.5 15L12.5 20H10V17.8711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditopc);
export default __webpack_public_path__ + "static/media/editopc.5c959e0034918c0837ffa14df1fb44f7.svg";
export { ForwardRef as ReactComponent };